module.exports = __webpack_public_path__ + "img/logo.ef2e5b9d.png";